
import apiConfig from '@/config/api.config'
import ImageUploader from '@/components/common/ImageUploader.vue'

export default {
  name: 'HomePageManage',
  components: {
    ImageUploader
  },
  data () {
    return {
      currentTab: 'home',
      tabs: [
        { key: 'home', label: '首页配置' },
        { key: 'promotion', label: '促销页' },
        { key: 'hot', label: '热销页' },
        { key: 'new', label: '新品页' }
      ],
      productDetails: {},
      searchKeywords: '',
      hotRankList: [],
      homeBanners: [
        { image: '', url: '', type: 'page' }
      ],
      pageBanners: {
        promotion: { image: '', url: '' },
        hot: { image: '', url: '' },
        new: { image: '', url: '' }
      },
      featuredProductIds: [],
      pageProducts: {
        promotion: [],
        hot: [],
        new: []
      },
      // 搜索相关
      featuredSearchKeyword: '',
      featuredSearchResults: [],
      featuredSearching: false,
      promotionSearchKeyword: '',
      promotionSearchResults: [],
      promotionSearching: false,
      hotSearchKeyword: '',
      hotSearchResults: [],
      hotSearching: false,
      newSearchKeyword: '',
      newSearchResults: [],
      newSearching: false,
      searchTimers: {}
    }
  },
  async created () {
    await this.fetchConfigs()
    this.fetchProductDetails()
  },
  methods: {
    // 已选商品回显：按 id 批量取详情（/products?ids= 一次取全命中集，不吃默认 limit 截断）。
    // 不再依赖"预拉全量商品快照"——那套在商品量超过快照上限时会静默丢商品。
    async fetchProductDetails () {
      const ids = [
        ...this.featuredProductIds,
        ...this.pageProducts.promotion,
        ...this.pageProducts.hot,
        ...this.pageProducts.new
      ].filter(id => !this.productDetails[id])
      if (!ids.length) return
      try {
        const res = await this.axios.get(apiConfig.apiList.getProducts, {
          params: { ids: ids.slice(0, 50).join(',') }
        })
        if (res.data.code === 200) {
          const map = { ...this.productDetails }
          res.data.data.forEach(p => { map[p.id] = p })
          this.productDetails = map
        }
      } catch (err) {
        console.error('获取商品详情失败:', err)
      }
    },
    async fetchConfigs () {
      try {
        const token = localStorage.getItem('token')
        const res = await this.axios.get('/admin/config', {
          headers: { Authorization: `Bearer ${token}` }
        })
        if (res.data.code === 200) {
          const configData = res.data.data
          // 搜索关键词
          if (configData.search_keywords) {
            try {
              const keywords = Array.isArray(configData.search_keywords) ? configData.search_keywords : JSON.parse(configData.search_keywords)
              this.searchKeywords = keywords.join('\n')
            } catch (e) {}
          }
          // 首页Banner（旧数据无 enabled → 归一化为 true，勾选框双向可直接改）
          if (configData.home_banners) {
            try {
              const banners = Array.isArray(configData.home_banners) ? configData.home_banners : JSON.parse(configData.home_banners)
              this.homeBanners = banners.map(b => ({ ...b, enabled: b.enabled !== false }))
            } catch (e) {}
          }
          // 精选商品
          if (configData.featured_products) {
            try {
              this.featuredProductIds = Array.isArray(configData.featured_products) ? configData.featured_products : JSON.parse(configData.featured_products)
            } catch (e) {}
          }
          // 促销页Banner
          if (configData.promotion_banner) {
            try {
              const data = typeof configData.promotion_banner === 'object' ? configData.promotion_banner : JSON.parse(configData.promotion_banner)
              this.pageBanners.promotion = { image: data.banner_image || '', url: data.banner_url || '' }
            } catch (e) {}
          }
          // 热销页Banner
          if (configData.hot_banner) {
            try {
              const data = typeof configData.hot_banner === 'object' ? configData.hot_banner : JSON.parse(configData.hot_banner)
              this.pageBanners.hot = { image: data.banner_image || '', url: data.banner_url || '' }
            } catch (e) {}
          }
          // 新品页Banner
          if (configData.new_banner) {
            try {
              const data = typeof configData.new_banner === 'object' ? configData.new_banner : JSON.parse(configData.new_banner)
              this.pageBanners.new = { image: data.banner_image || '', url: data.banner_url || '' }
            } catch (e) {}
          }
          // 促销商品
          if (configData.promotion_products) {
            try {
              this.pageProducts.promotion = Array.isArray(configData.promotion_products) ? configData.promotion_products : JSON.parse(configData.promotion_products)
            } catch (e) {}
          }
          // 热销商品
          if (configData.hot_products) {
            try {
              this.pageProducts.hot = Array.isArray(configData.hot_products) ? configData.hot_products : JSON.parse(configData.hot_products)
            } catch (e) {}
          }
          // 新品商品
          if (configData.new_products) {
            try {
              this.pageProducts.new = Array.isArray(configData.new_products) ? configData.new_products : JSON.parse(configData.new_products)
            } catch (e) {}
          }
          // 热搜榜
          if (configData.hot_rank_list) {
            try {
              this.hotRankList = Array.isArray(configData.hot_rank_list) ? configData.hot_rank_list : JSON.parse(configData.hot_rank_list)
            } catch (e) {}
          }
        }
      } catch (err) {
        console.error('获取配置失败:', err)
      }
    },
    getProductById (id) {
      return this.productDetails[id] || null
    },
    switchTab (key) {
      this.currentTab = key
    },
    getUrlPlaceholder (type) {
      const map = {
        page: '/promotion, /help/how-to-order（教程）等',
        product: '商品ID',
        url: 'https://...'
      }
      return map[type] || ''
    },
    addHomeBanner () {
      this.homeBanners.push({ image: '', url: '', type: 'page', enabled: true })
    },
    // 删除即落库（2026-09-19 Banner 残留修复）：此前只 splice 本地数组，必须再点
    // 「保存Banner配置」才写库——管理员见列表已删便切走，DB 未变 → 前台 banner 一直残留。
    // 删除是明确的破坏性操作，即时保存；编辑图片/链接等仍走底部保存按钮。
    // 与「停用」（enabled 勾选框，Public 端 filter enabled!==false）语义分开：删除=数组移除。
    async removeHomeBanner (index) {
      const [removed] = this.homeBanners.splice(index, 1)
      const ok = await this.saveConfig('home_banners', this.homeBanners, true)
      if (ok) {
        this.$q && this.$q.notify({ message: 'Banner 已删除并保存', color: 'positive', position: 'top' })
      } else {
        // 保存失败：放回原位，避免「界面已删、库里还在」的错觉状态
        this.homeBanners.splice(index, 0, removed)
        this.$q && this.$q.notify({ message: '删除保存失败，已还原，请重试', color: 'negative', position: 'top' })
      }
    },
    // 搜索商品（防抖）
    debouncedSearchProducts (type) {
      if (this.searchTimers[type]) {
        clearTimeout(this.searchTimers[type])
      }
      this.searchTimers[type] = setTimeout(() => {
        this.searchProducts(type)
      }, 300)
    },
    async searchProducts (type) {
      const keywordMap = {
        featured: 'featuredSearchKeyword',
        promotion: 'promotionSearchKeyword',
        hot: 'hotSearchKeyword',
        new: 'newSearchKeyword'
      }
      const resultsMap = {
        featured: 'featuredSearchResults',
        promotion: 'promotionSearchResults',
        hot: 'hotSearchResults',
        new: 'newSearchResults'
      }
      const searchingMap = {
        featured: 'featuredSearching',
        promotion: 'promotionSearching',
        hot: 'hotSearching',
        new: 'newSearching'
      }
      const existingMap = {
        featured: this.featuredProductIds,
        promotion: this.pageProducts.promotion,
        hot: this.pageProducts.hot,
        new: this.pageProducts.new
      }

      const keyword = this[keywordMap[type]].trim()
      if (!keyword) {
        this[resultsMap[type]] = []
        return
      }

      // 竞态守卫：防抖后响应仍可能乱序，只认最后一次发起的搜索
      this._searchSeq = (this._searchSeq || 0) + 1
      const seq = this._searchSeq
      this[searchingMap[type]] = true
      try {
        // 移动端同款搜索端点：名称/品牌/规格/车型/品类/内部编码/条码/别名/拼音码全召回，无快照池截断
        const res = await this.axios.get(apiConfig.apiList.getProducts, {
          params: { search: keyword, limit: 20 }
        })
        if (seq !== this._searchSeq) return
        if (res.data.code === 200) {
          const data = res.data.data || []
          // 缓存搜索结果对象，添加进槽位后即时回显，不依赖再次查询
          const cache = this._searchCache || {}
          data.forEach(p => { cache[p.id] = p })
          this._searchCache = cache
          this[resultsMap[type]] = data.filter(p => !existingMap[type].includes(p.id))
        }
      } catch (err) {
        console.error('搜索商品失败:', err)
      } finally {
        if (seq === this._searchSeq) this[searchingMap[type]] = false
      }
    },
    ensureProductDetail (productId) {
      const cached = this._searchCache && this._searchCache[productId]
      if (!cached || this.productDetails[productId]) return
      this.productDetails = { ...this.productDetails, [productId]: cached }
    },
    addFeaturedProduct (productId) {
      if (this.featuredProductIds.length < 10 && !this.featuredProductIds.includes(productId)) {
        this.featuredProductIds.push(productId)
        this.ensureProductDetail(productId)
        this.featuredSearchKeyword = ''
        this.featuredSearchResults = []
      }
    },
    removeFeaturedProduct (index) {
      this.featuredProductIds.splice(index, 1)
    },
    shuffleFeaturedProducts () {
      // Fisher-Yates 洗牌算法
      const arr = [...this.featuredProductIds]
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]]
      }
      this.featuredProductIds = arr
    },
    addPageProduct (page, productId) {
      if (!this.pageProducts[page].includes(productId)) {
        this.pageProducts[page].push(productId)
        this.ensureProductDetail(productId)
        // 清空搜索
        const keywordMap = {
          promotion: 'promotionSearchKeyword',
          hot: 'hotSearchKeyword',
          new: 'newSearchKeyword'
        }
        const resultsMap = {
          promotion: 'promotionSearchResults',
          hot: 'hotSearchResults',
          new: 'newSearchResults'
        }
        this[keywordMap[page]] = ''
        this[resultsMap[page]] = []
      }
    },
    removePageProduct (page, index) {
      this.pageProducts[page].splice(index, 1)
    },
    // quiet=true 供调用方自定义成功提示（如删除即存场景提示「已删除并保存」）
    async saveConfig (key, value, quiet = false) {
      try {
        const token = localStorage.getItem('token')
        await this.axios.put(
          `admin/config/${key}`,
          { config_value: JSON.stringify(value) },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        if (!quiet) this.$q && this.$q.notify({ message: '保存成功', color: 'positive', position: 'top' })
        return true
      } catch (err) {
        if (!quiet) this.$q && this.$q.notify({ message: '保存失败', color: 'negative', position: 'top' })
        return false
      }
    },
    saveSearchKeywords () {
      const keywords = this.searchKeywords.split('\n').filter(k => k.trim())
      this.saveConfig('search_keywords', keywords)
    },
    saveHomeBanners () {
      this.saveConfig('home_banners', this.homeBanners)
    },
    saveFeaturedProducts () {
      this.saveConfig('featured_products', this.featuredProductIds)
    },
    async savePageBanner (page) {
      const data = {
        banner_image: this.pageBanners[page].image,
        banner_url: this.pageBanners[page].url
      }
      await this.saveConfig(`${page}_banner`, data)
    },
    savePageProducts (page) {
      this.saveConfig(`${page}_products`, this.pageProducts[page])
    },
    addHotRank () {
      this.hotRankList.push({ keyword: '', search_count: 0 })
    },
    removeHotRank (index) {
      this.hotRankList.splice(index, 1)
    },
    saveHotRank () {
      // 过滤掉空白项，按搜索次数排序
      const list = this.hotRankList
        .filter(item => item.keyword && item.keyword.trim())
        .map(item => ({
          keyword: item.keyword.trim(),
          search_count: parseInt(item.search_count) || 0
        }))
        .sort((a, b) => b.search_count - a.search_count)
      this.hotRankList = list
      this.saveConfig('hot_rank_list', list)
    }
  }
}
